const PRE = 'APP_';
export const APPBAR = PRE + 'APPBAR';


// WEBPACK FOOTER //
// ./src/App/actionTypes.js